import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface NavArrowRightIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const NavArrowRightIcon = ({ className, ...props }: NavArrowRightIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 6L15 12L9 18"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default NavArrowRightIcon;
